import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../../../../store/selectors';
import {
    selectFlowOfFunds,
    selectFlowOfFundsLoading,
    selectFlowOfFundsRequested,
} from '../../../../slices/marketplace/flow-of-funds/flow-of-funds.slice';
import { GetFlowOfFunds } from '../../../../slices/marketplace/flow-of-funds/thunks/get-flow-of-funds.thunk';

export const useFlowOfFunds = (engagementId: number) => {
    const dispatch = useDispatch();
    const flowOfFunds = useStateSelector((state) =>
        selectFlowOfFunds(state, engagementId)
    );
    const isLoading = useStateSelector(selectFlowOfFundsLoading);
    const alreadyRequested = useStateSelector((state) =>
        selectFlowOfFundsRequested(state, engagementId)
    );

    useEffect(() => {
        if (!engagementId) {
            return;
        }
        if (flowOfFunds) {
            // Re-entering the tab with data already on screen: refresh in the background so
            // another party's changes appear — the slice keeps the loading flag off for an
            // already-loaded engagement, so nothing blanks.
            (dispatch as any)(GetFlowOfFunds(engagementId));
            return;
        }
        if (isLoading || alreadyRequested) {
            return;
        }
        (dispatch as any)(GetFlowOfFunds(engagementId));
    }, [engagementId]);

    return { flowOfFunds, isLoading };
};
